import React from 'react';

const PrivacyPolicy = () => {
    return (
        <section className="privacy-section py-80 bg-gray-50 position-relative">
            <style>{`
                .policy-card {
                    background: #ffffff;
                    border: 1px solid #EFEFEF;
                    border-radius: 16px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.03);
                    transition: all 0.3s ease;
                }
                .policy-card:hover {
                    box-shadow: 0 8px 30px rgba(0,0,0,0.06);
                }
                .policy-icon-box {
                    width: 44px;
                    height: 44px;
                    border-radius: 12px;
                    background: #EAF8EE;
                    color: var(--main-600, #2FA84F);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 22px;
                    flex-shrink: 0;
                }
                .policy-notice-box {
                    background: #F8FDF9;
                    border-left: 4px solid var(--main-600, #2FA84F);
                    padding: 16px 20px;
                    border-radius: 0 12px 12px 0;
                    margin: 16px 0;
                }
                .policy-bullet-list {
                    padding-left: 20px;
                    margin-bottom: 16px;
                }
                .policy-bullet-list li {
                    margin-bottom: 8px;
                    color: #4A5568;
                    line-height: 1.65;
                }
            `}</style>

            <div className="container container-lg">
                {/* Header Banner */}
                <div className="text-center mb-48 wow fadeInUp" data-wow-duration="0.6s">
                    <span className="text-main-600 fw-semibold text-uppercase mb-12 d-inline-block px-16 py-6 rounded-pill bg-main-50" style={{ letterSpacing: '1px', fontSize: 13 }}>
                        Privacy &amp; Security
                    </span>
                    <h2 className="fw-bold mb-16">Privacy Policy</h2>
                    <p className="text-gray-600 max-w-700 mx-auto" style={{ fontSize: 16, lineHeight: 1.7 }}>
                        At Healthy Home (<strong className="text-main-600">healthyhomeonline.in</strong>), we value your trust and are committed to safeguarding your privacy, personal details, and transaction data.
                    </p>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="d-flex flex-column gap-32">

                            {/* Section 1: Information We Collect */}
                            <div className="policy-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="policy-icon-box">
                                        <i className="ph ph-user-focus" />
                                    </div>
                                    <h4 className="fw-bold mb-0">1. Information We Collect</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    When you visit our website, register an account, or place an order for our food products and cold-pressed edible oils, we collect information necessary to fulfill your request:
                                </p>
                                <ul className="policy-bullet-list">
                                    <li><strong>Contact Details:</strong> Full name, phone number (+91), email address, and billing/shipping address.</li>
                                    <li><strong>Order Details:</strong> Items purchased, quantities, delivery preferences, and order history.</li>
                                    <li><strong>Technical Data:</strong> IP address, device type, and browser details used for fraud detection and security.</li>
                                </ul>
                            </div>

                            {/* Section 2: Payment Security */}
                            <div className="policy-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="policy-icon-box">
                                        <i className="ph ph-shield-check" />
                                    </div>
                                    <h4 className="fw-bold mb-0">2. Payment Security &amp; Third-Party Processing</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    Customers may use payment methods made available on our website (UPI, Cards, Net Banking). Online payments are securely processed through authorised third-party payment gateway providers.
                                </p>
                                <div className="policy-notice-box">
                                    <p className="mb-0 text-gray-800 text-sm">
                                        <strong>No Storage of Sensitive Card Data:</strong> Healthy Home does not directly store complete debit card numbers, credit card details, CVV, or other sensitive payment authentication information where payment is processed by an authorised third-party payment provider.
                                    </p>
                                </div>
                            </div>

                            {/* Section 3: How We Use Your Information */}
                            <div className="policy-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="policy-icon-box">
                                        <i className="ph ph-gear-six" />
                                    </div>
                                    <h4 className="fw-bold mb-0">3. How We Use Your Information</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    We use the information collected exclusively for legitimate business and fulfillment purposes:
                                </p>
                                <ul className="policy-bullet-list">
                                    <li>To process, confirm, ship, and deliver your orders accurately.</li>
                                    <li>To communicate order status, dispatch alerts, invoices, and delivery updates.</li>
                                    <li>To provide customer support and address any return or refund inquiries.</li>
                                    <li>To detect, prevent, and protect against fraudulent or unauthorized transactions.</li>
                                </ul>
                            </div>

                            {/* Section 4: Third-Party Services */}
                            <div className="policy-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="policy-icon-box">
                                        <i className="ph ph-handshake" />
                                    </div>
                                    <h4 className="fw-bold mb-0">4. Third-Party Services &amp; Logistics</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    Our website uses third-party services for payment processing, logistics and shipment tracking, communication, and website analytics.
                                </p>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    We only share the necessary delivery address and contact details with our courier partners to facilitate the safe and timely delivery of your packages. Use of such third-party services is subject to their respective terms and privacy policies.
                                </p>
                            </div>

                            {/* Section 5: Data Protection & Website Use */}
                            <div className="policy-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="policy-icon-box">
                                        <i className="ph ph-lock-key" />
                                    </div>
                                    <h4 className="fw-bold mb-0">5. Data Protection &amp; Acceptable Website Use</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    We implement standard security measures to protect your personal data against unauthorized access, loss, or alteration.
                                </p>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    Users agree not to misuse the website, attempt unauthorized access, or use the website for fraudulent activities. The brand name, logo, photographs, and website materials are protected intellectual property of Healthy Home.
                                </p>
                            </div>

                            {/* Section 6: Contact Information */}
                            <div className="policy-card p-32 wow fadeInUp" data-wow-duration="0.5s" style={{ background: 'linear-gradient(135deg, #F8FDF9 0%, #FFFFFF 100%)', border: '1px solid #CDE8D5' }}>
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="policy-icon-box" style={{ background: 'var(--main-600, #2FA84F)', color: '#FFFFFF' }}>
                                        <i className="ph ph-envelope-open" />
                                    </div>
                                    <div>
                                        <h4 className="fw-bold mb-4">6. Contact Us on Privacy Matters</h4>
                                        <span className="text-sm text-gray-600">Healthy Home &bull; healthyhomeonline.in</span>
                                    </div>
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <p className="text-sm text-gray-500 mb-4">Phone Support</p>
                                        <a href="tel:9449818329" className="text-main-600 fw-semibold text-md">+91 9449818329</a>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="text-sm text-gray-500 mb-4">Official Website</p>
                                        <a href="https://healthyhomeonline.in" target="_blank" rel="noopener noreferrer" className="text-main-600 fw-semibold text-md">healthyhomeonline.in</a>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="text-sm text-gray-500 mb-4">Location</p>
                                        <span className="text-gray-900 fw-semibold text-md">Bengaluru, Karnataka, India</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PrivacyPolicy;
